export default "__VITE_ASSET__DpgVubUk__"